import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AuthState, PayloadInitializeAuthorization } from './types';

const initialState: AuthState = {};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    initializeAuthorization: (state, action: PayloadAction<PayloadInitializeAuthorization>) => {
      state.authenticationKey = action.payload.authenticationKey;
      state.codeVerifier = action.payload.codeVerifier;
    },
    resetAuth: () => initialState,
  },
});

export const {
  actions: { resetAuth, initializeAuthorization },
  reducer: authSliceReducer,
} = authSlice;
